import React from "react";

import { MessageContainer, MessageInfo } from "./Message.elements";

function Message({ message }) {
  return (
    <MessageContainer>
      <img src={message.userImage} alt="user" />
      <MessageInfo>
        <h4>
          {message.user}{" "}
          <span>{new Date(message.timestamp?.toDate()).toUTCString()}</span>
        </h4>
        <p>{message.message}</p>
      </MessageInfo>
    </MessageContainer>
  );
}

export default Message;
